// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SocialMail = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g transform="translate(1 1)" fill="none" fillRule="evenodd">
			<circle stroke="#658E93" cx={20} cy={20} r={20} />
			<path
				d="M26.68 16.68V15L20 19.18 13.32 15v1.68L20 20.82l6.68-4.14zm0-3.36c.442 0 .827.17 1.152.508.326.339.488.73.488 1.172v10c0 .443-.162.833-.488 1.172-.325.338-.71.508-1.152.508H13.32c-.442 0-.827-.17-1.152-.508A1.641 1.641 0 0 1 11.68 25V15c0-.443.162-.833.488-1.172.325-.338.71-.508 1.152-.508h13.36z"
				fill="#658E93"
			/>
		</g>
	</svg>
);
export default SocialMail;
